'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var formatFileSize = exports.formatFileSize = function formatFileSize(bytes) {
  var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  if (bytes === 0) return '0 Bytes';

  var k = 1024;
  var sizes = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  var i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(Math.max(0, precision))) + ' ' + sizes[i];
};

var dataURIToBlob = exports.dataURIToBlob = function dataURIToBlob(dataURI) {
  var byteString = void 0;

  if (dataURI.split(',')[0].indexOf('base64') >= 0) {
    byteString = window.atob(dataURI.split(',')[1]);
  } else {
    byteString = unescape(dataURI.split(',')[1]);
  }

  var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

  var ia = new Uint8Array(byteString.length);

  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  return new window.Blob([ia], { type: mimeString });
};